import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";
import { actions } from "./actions";
import { modules } from "../../constants";
import { viewOptions } from "../../agent-production/constants/savedAgents";

export const intialPersistedSavedAgentsView = Object.freeze({
    selectedView: viewOptions[1],
});

export const initialSavedAgentStore = {
    ...intialPersistedSavedAgentsView,
    selectedListByModule: ({
        [modules.proficiencyMetrics.agents]: undefined,
        [modules.proficiencyMetrics.savedAgents]: undefined,
    }),
    agentList: undefined,
    propertyTypeNames: [],
    isLoading: false,
    agentListsCheckedValues: {},
    globalSavedAgentListId: undefined,
    popoverDataForAddAgentList: {},
    manualSearchData: null,
    activities: null,
    isLoadingActivities: false,
    dirtyListIds: {},
}

const savedAgentsStore = (set, get) => ({
    ...initialSavedAgentStore,
    ...actions(set, get),
});

export const useSavedAgentsStore = createWithEqualityFn(
    devtools(
        persist(
            savedAgentsStore,
            {
                name: 'saved_agents_state',
                storage: createJSONStorage(() => localStorage)
            }
        )
    )
);
